import apiClient from "./apiClient";

export const validateLicense = async () => {
  try {
    const response = await apiClient.get("/subscription/validate");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateLicense = async (licenseId, payload) => {
  try {
    const response = await apiClient.put(
      `/subscription/update_usage/${licenseId}`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLicensingUsageDetails = async (subscription_id) => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.get(`/subscription/usages/${subscription_id}`, {
      headers: {
        website_id: websiteId,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const contactSales = async (formData) => {
  try {
    const response = await apiClient.post(`/subscription/contact-sales`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
